// Browser polyfills and fixes that should be included on every page.
define('core/global/compensatrs',["jquery", "core/global/state", "modernizr"], function ($, state, Modernizr) {
    console.log('global/compensatrs');

    return {

        //************ FEATURE DETECTION HANDLING ******************
        // Add modernizr html5 feature detection handling here
        handleUnsupportedHtml5: function() {
            /* If CSS transitions are not supported, delegate transition() calls to animate().
            ** Note: if you specify an easing, please make sure to define that easing in jQuery. 
            ** Likewise, jQuery's "swing" easing is not supported by CSS, although you could
            **  approximate it in CSS by doing this: http://stackoverflow.com/a/9245729/925475 */
            if (!$.support.transition) {
                $.fn.transition = $.fn.animate;
            }
        },

        // Add detection for non standard css properties here
        customCSSDetection: function() {
            Modernizr.addTest('appearance', function() {
                return Modernizr.testAllProps('appearance') && (document.documentMode === undefined || document.documentMode > 7);
            });
        },

        // remove href of phone links
        // this is a bit hacky -- if it isn't a touch device, simply remove the href from the a tag.
        handleTelLinks: function() {
            if (!EFTOURS.device.isTouch) {
                $(".tel-link").removeAttr("href");
            }
        },

        // Fix for icon fonts in ie8 that forces a repaint for pseudo elements.
        ie8FontFix: function() {
            if (state.oldIe()) {
                var head = document.getElementsByTagName('head')[0],
                    style = document.createElement('style');
                style.type = 'text/css';
                style.styleSheet.cssText = ':before,:after{content:"" !important';
                head.appendChild(style);
                setTimeout(function() {
                    head.removeChild(style);
                }, 0);
            }
        },

        //************ REPLACE HTML5 PLACEHOLDER TEXT FUNCTIONALITY ON OLD BROWSERS ******************
        fakePlaceholder: function() {
            // Fake placehold if using ie8 or ie9
            if (!Modernizr.input.placeholder) {
                $("input").each(
                    function() {
                        var inputField = $(this);
                        if (inputField.val() == "" && inputField.attr("placeholder") != "") {

                            inputField.val(inputField.attr("placeholder"));

                            inputField.focus(function() {
                                if (inputField.val() == inputField.attr("placeholder")) {
                                    inputField.val("");
                                }
                            });

                            inputField.blur(function() {
                                if (inputField.val() == "") {
                                    inputField.val(inputField.attr("placeholder"));
                                }
                            });

                            $(inputField).closest('form').on("submit", function() {
                                var form = $(this);
                                if (!form.hasClass('placeholderPending')) {
                                    $('input', this).each(function() {
                                        var clearInput = $(this);
                                        if (clearInput.val() == clearInput.attr("placeholder")) {
                                            clearInput.val("");
                                        }
                                    });
                                    form.addClass('placeholderPending');
                                }
                            });

                        }
                    });
            }
        }
    };
});
